module.exports = __webpack_public_path__ + "img/weibo-avatars.acf83034.png";